import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const Page = lazy(() => import('~/features/samtek/customer-deleted/page-client'))

export const Route = createFileRoute('/_authed/samtek/customer-deleted')({
  component: () => <Suspense fallback={null}><Page /></Suspense>,
})
